/**
 * Organization Prefix Constants
 * These constants represent the organization prefixes used throughout the application.
 * Organization prefixes are typically 2-3 character codes that identify different organizations.
 */

export const ORGANIZATION_PREFIXES = {
  UBS: 'UB',
};
